import type { User } from '@/types';
import { BASE_PATH } from './base-path';

const TOKEN_KEY = 'instask_token';
const USER_KEY = 'instask_user';
const AUTH_CHANGE_EVENT = 'instask:auth-change';
const COOKIE_PATH = BASE_PATH || '/';

// Cookie name must match middleware
export const TOKEN_COOKIE = 'instask_token';

export function getToken(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
  // Also set cookie so middleware and server components can read it
  document.cookie = `${TOKEN_COOKIE}=${token}; path=${COOKIE_PATH}; max-age=${60 * 60 * 24}; SameSite=Lax`;
  window.dispatchEvent(new Event(AUTH_CHANGE_EVENT));
}

export function removeToken(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  document.cookie = `${TOKEN_COOKIE}=; path=${COOKIE_PATH}; max-age=0`;
  // Limpia cookie legacy con path=/ por si quedó de un run sin basePath
  if (COOKIE_PATH !== '/') {
    document.cookie = `${TOKEN_COOKIE}=; path=/; max-age=0`;
  }
  window.dispatchEvent(new Event(AUTH_CHANGE_EVENT));
}

export function getStoredUser(): User | null {
  if (typeof window === 'undefined') return null;
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as User;
  } catch {
    return null;
  }
}

export function setStoredUser(user: User): void {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  window.dispatchEvent(new Event(AUTH_CHANGE_EVENT));
}

export function onAuthChange(callback: () => void) {
  window.addEventListener(AUTH_CHANGE_EVENT, callback);
  window.addEventListener('storage', callback);
  return () => {
    window.removeEventListener(AUTH_CHANGE_EVENT, callback);
    window.removeEventListener('storage', callback);
  };
}
